import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { getUnitTree } from "@/service/identity";
import { highlightHtml } from "@/utils/util";
export default {
  name: "orgTreeModal",
  props: {
    disabledUnit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      dataTree: [],
      tagTree: [],
      searchKeys: "",
      entityList: []
    };
  },
  methods: {
    onCheckChangeOrgTree(selection, entity) {
      let {
        key,
        type
      } = entity;
      let data = this.entityList.find(item => item.key === key);
      if (data) {
        this.entityList = this.entityList.filter(item => item.key !== key);
      } else {
        this.entityList.push({
          ...entity,
          icon: type === "USER" ? "md-person" : "md-folder"
        });
      }
    },
    formatDepartData(data) {
      return data.map(item => {
        let {
          children,
          code,
          name
        } = item;
        let childrenDept = [];
        if (children.length > 0) {
          childrenDept = this.formatDepartData(children);
        }
        return {
          key: code,
          disabled: this.disabledUnit,
          name,
          children: [...childrenDept],
          type: "ORG"
        };
      });
    },
    formatUserData(data) {
      return data.map(item => {
        let {
          userId,
          userName
        } = item;
        return {
          key: userId,
          name: userName,
          children: [],
          type: "USER"
        };
      });
    },
    formatTree(data) {
      let {
        name,
        code,
        children
      } = data;
      let childrenDept = this.formatDepartData(children);
      return [{
        name,
        key: code,
        disabled: this.disabledUnit,
        children: [...childrenDept],
        expand: true,
        type: "ORG"
      }];
    },
    renderContent(h, {
      data
    }) {
      let nodeChildren = data.children;
      let flag = nodeChildren ? nodeChildren.length : false;
      let html = highlightHtml(data.name, this.searchKeys);
      return h("div", [h("span", [h("Icon", {
        "attrs": {
          "type": flag ? "md-folder" : "md-person"
        },
        "class": "mr-2 text-[#3D7FFF]"
      }), h("span", {
        "domProps": {
          "innerHTML": html
        }
      })])]);
    },
    async getOrgTree() {
      let {
        data: {
          result,
          retVal
        }
      } = await getUnitTree();
      if (result === 0) {
        this.dataTree = this.formatTree(retVal);
      }
    },
    async open() {
      await this.getOrgTree();
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    async confirm() {
      let entityList = this.entityList;
      this.$emit("on-update", entityList);
      this.visible = false;
    }
  },
  computed: {
    filterTreeDataByKeyword() {
      const isIncludes = (node, keyword) => {
        let {
          children
        } = node;
        if (node.name.includes(keyword)) {
          return true;
        } else if (children && children.length) {
          for (let item of children) {
            let res = isIncludes(item, keyword);
            if (res) {
              return true;
            }
          }
        }
        return false;
      };
      const searchTree = (tree, keyword) => {
        let result = [];
        for (let item of tree) {
          if (item.name.includes(keyword)) {
            item.expand = true;
            result.push(item);
          } else if (item.children && isIncludes(item, keyword)) {
            item.expand = true;
            if (item.children) {
              item.children = searchTree(item.children, keyword);
            }
            result.push(item);
          }
        }
        return result;
      };
      let result = searchTree(JSON.parse(JSON.stringify(this.dataTree)), this.searchKeys);
      return result;
    },
    filterTreeData() {
      let nodelist = this.filterTreeDataByKeyword || [];
      const markChecked = (nodelist, parentNode) => {
        return nodelist.map(node => {
          if (node.key && this.entityList.some(entity => entity.key === node.key)) {
            node.checked = true; // 设置 checked 属性为 true
            parentNode ? parentNode.expand = true : null;
          } else {
            node.checked = false;
          }

          // 如果当前节点有子节点，递归处理子节点
          if (node.children && node.children.length > 0) {
            node.children = markChecked(node.children, node);
          }
          return node;
        });
      };
      return markChecked(JSON.parse(JSON.stringify(nodelist)));
    },
    filterTagData() {
      let nodelist = this.tagTree || [];
      const markChecked = nodelist => {
        return nodelist.map(node => {
          if (node.key && this.entityList.some(entity => entity.key === node.key)) {
            node.checked = true; // 设置 checked 属性为 true
          } else {
            node.checked = false;
          }

          // 如果当前节点有子节点，递归处理子节点
          if (node.children && node.children.length > 0) {
            node.children = markChecked(node.children);
          }
          return node;
        });
      };
      return markChecked(JSON.parse(JSON.stringify(nodelist)));
    }
  },
  onMounted() {}
};